export default __webpack_public_path__ + "static/media/MultichoiceIcon.90f404fc.svg";